import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Async thunk to load the waitlist
export const fetchMyWaitList = createAsyncThunk(
    "myWaitList/fetchMyWaitList",
    async ({ request, userId }, { rejectWithValue }) => {
        try {
            const response = await agent.get(`${API.LOAD_MY_WAITLIST}/${userId}`, {
                params: request,
            });

            const data = response.data?.data?.data || [];
            const pagination = response.data?.data?.pagination || {};

            return { data, pagination };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const myWaitListSlice = createSlice({
    name: "myWaitList",
    initialState: {
        data: [],
        pagination: {},
        loading: false,
        found: true, // corresponds to loadNotFoundDataSuccess
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMyWaitList.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(fetchMyWaitList.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.pagination = action.payload.pagination;
                state.found = action.payload.data.length > 0;
                state.loading = false;
            })
            .addCase(fetchMyWaitList.rejected, (state, action) => {
                state.loading = false;
                state.found = false;
            });
    },
});

export default myWaitListSlice.reducer;
